import React, { useState } from 'react';
import { ICreateProfile, IUpdateProfile } from '../../@types';
import RetailIcon from '../../assets/icons/RetailIcon';
import ServiceIcon from '../../assets/icons/ServiceIcon';


interface BusinessTypeStepProps {
  setActiveStep: (step: number) => void;
  handleUpdateProfile: (profile: IUpdateProfile ) => Promise<void>;
}

const BusinessTypeStep: React.FC<BusinessTypeStepProps> = ({ setActiveStep, handleUpdateProfile }) => {
  const [selectedType, setSelectedType] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false); 

  const handleNext = async () => {
    try {
      if (selectedType === null) {
        setErrorMessage("Please select a business type before proceeding.");
        return;
      }

      const profileData: IUpdateProfile = {
        businessType: selectedType,
      };
      console.log('Data sent during handleNext:', profileData);
      setIsLoading(true); 
      await handleUpdateProfile(profileData);
      //@ts-ignore
      setActiveStep((prev: number) => prev + 1);
    } catch (error: any) {
      setErrorMessage(error.message);
    } finally {
      setIsLoading(false); 
    }
  };

  return (
    <div className="flex  flex-col justify-center xl:ml-[13em] biglg:ml-[9em] lg:ml-[5em] xl:mt-[10em] mt-[3em] md:mt-[10em] 2xl:mt-[13em]">
      <h2 className="lg:text-[24px] text-[20px] md:text-[24px] bigmd:text-[24px] text-[#292D32] font-bold">Business Type</h2>
      <p className="mb-4 lg:text-[16px] font-light text-[14px] md:text-[16px] bigmd:text-[16px]">Select a type that best fits your business</p>
      <div
        className={`flex border xl:w-[434px] rounded-lg bg-white h-[109px] mt-[2em] lg:w-[434px] ${
          selectedType === 'retail' ? 'border-blue-500' : 'border-transparent'
        } ${selectedType === 'retail' ? 'bg-[#FDE9D1]' : ''}`}
        onClick={() => setSelectedType('retail')}
      >
        <div className="px-4 py-6">
          <ServiceIcon />
        </div>
        <div className="flex flex-col mt-[1em]">
          <h2 className="xl:text-[16px] text-[14px] text-[#101010] md:text-[16px] bigmd:text-[16px]">Retail Based Business</h2>
          <p className="xl:text-[14px] text-[#4E4E4E] font-light text-[12px] md:text-[14px] bigmd:text-[14px]">
            I sell products directly to consumers <br /> through physical stores or online platforms.
          </p>
        </div>
      </div>

      <div
        className={`flex border xl:w-[434px] bg-white rounded-lg mt-[1.5em] h-[109px] lg:w-[434px] ${
          selectedType === 'service' ? 'border-blue-500' : 'border-transparent'
        } ${selectedType === 'service' ? 'bg-[#FDE9D1]' : ''}`}
        onClick={() => setSelectedType('service')}
      >
        <div className="px-4 py-6">
          <ServiceIcon />
        </div>
        <div className="flex flex-col mt-[1em]">
          <h2 className="xl:text-[16px] text-[#101010] text-[14px] md:text-[16px] bigmd:text-[16px]">Service Based Business</h2>
          <p className="xl:text-[14px] text-[#4E4E4E] font-light text-[12px] md:text-[14px] bigmd:text-[14px]">
            I offer services to clients, such as <br /> consulting, cleaning, or freelancing.
          </p>
        </div>
      </div>
      {errorMessage && <p className="text-red-500">{errorMessage}</p>}
      <button
        className="bg-[#044E97] text-[16px]  h-[48px] 540:mr-[5em] w-[350px]  rounded-md text-[#ffffff] 375:ml-[-0.3em] 414:ml-[1em] 360:ml-[-0.6em] ml-[0.3em] 412:ml-[1em] md:mr-[-1em] mt-[2.7em] md:mt-[2.9em] xl:mt-[2em] md:w-[440px] lg:ml-[0.3em]  lg:mt-[2em] xl:w-[434px] xl:mr-[-0.5em] mb-[2em]"
        onClick={handleNext}
        disabled={isLoading} 
      >
          {isLoading ? 'Loading...' : 'Next Step'} 
     
      </button>
    </div>
  );
};

export default BusinessTypeStep;

